export type ExpandedSection =
  | { type: 'subject'; subjectUid: string }
  | { type: 'details' }
  | null

export function isSubjectOpen(
  state: ExpandedSection,
  subjectUid?: string | null
) {
  return state?.type === 'subject' && state.subjectUid === subjectUid
}

export function toggleSubject(
  state: ExpandedSection,
  subjectUid?: string | null
): ExpandedSection {
  return !subjectUid || isSubjectOpen(state, subjectUid)
    ? null
    : { type: 'subject', subjectUid }
}

export function toggleDetails(state: ExpandedSection): ExpandedSection {
  return state?.type === 'details' ? null : { type: 'details' }
}
